import {ajax} from './ajax'

//在线答疑
//1、获取学生列表
export const reqChatStuList = (paramets) => ajax(`/jxtalk/jxTalk/getStuTalkList`, paramets)

//2、获取聊天列表
export const reqChatDetail = (paramets) => ajax(`/jxtalk/jxTalk/getJsdyList`, paramets)

//3、回复学生
export const reqChatReplyStu = (paramets) => ajax(`/jxtalk/jxTalk/add`, paramets, 'post')

//4、删除聊天
export const reqPlanDel = (paramets) => ajax(`/jxtalk/jxTalk/delete`, paramets, 'delete')

//5、教学讨论编辑
export const reqEditTalk = (paramets) => ajax(`/jxtalk/jxTalk/edit`, paramets, 'PUT')


